import React, { useContext } from 'react'
import { useAtomValue } from 'jotai'
import { useTranslation } from 'react-i18next'
import { Box, Button, Card, DataListItem } from '@node-space/ui-components'
import { SheetStatusCard } from 'components/SheetStatusCard/SheetStatusCard'
import { contactAtom } from 'pages/Contacts/atoms/contactAtoms'
import { WalletActionContext } from 'pages/Wallets/context/WalletSheetProvider'
import { channelPaymentUrlAtom } from './atoms/atoms'

export const ChannelPaymentComplete = () => {
  const { t } = useTranslation()
  const [walletAction] = useContext(WalletActionContext)
  const channelPaymentUrl = useAtomValue(channelPaymentUrlAtom)
  const contact = useAtomValue(contactAtom)

  return (
    <SheetStatusCard
      testid="channel-payment-complete"
      headline={t('payments.channelPayments.channelCreated')}
      status="success"
      ActionButtons={[
        <Button
          key="back-to-channel-payments"
          data-testid="back-to-channel-payments"
          onClick={() => {
            walletAction?.onClose()
            walletAction?.meta?.onPaymentChannelSuccess?.()
          }}
        >
          {t('done')}
        </Button>,
      ]}
    >
      <Box className="text-center" flexCol width="full" gapY={16}>
        <Card variant="static" emphasis full>
          <DataListItem
            id="channel-payment-url"
            layout="vertical"
            title={t('payments.channelPayments.channelUrl')}
            body={`${channelPaymentUrl.slice(0, 50)}...`}
            copyText={channelPaymentUrl}
          />
        </Card>
        <Box tag="p" className="text-body-regular text-foreground-subdued text-center">
          {t('payments.channelPayments.channelPaymentsCompleteDescription', {
            contactName: contact?.name,
          })}
        </Box>
      </Box>
    </SheetStatusCard>
  )
}
